/**
 *  @author:        Cloud for Good
 *  @description:   Controls the client side logic of the Gift Options box that can be used in multiple places around the giving site.
 *
 *  History
 *  <Date>        <Author Name>       <Reference #>       <Change Description>
 *  2022-09-30    Cloud for Good           N/A              Initial creation
 *  2024-06-25    Julie Branyan (CFG)      CFG-136          Update gift amounts selector
 *  2024-10-16    Jassin Yacks (CFG)       CFG-678          Added aria-selected attributes to the fund amounts and set the default states
 *  2025-01-02    Jassin Yacks (CFG)       CFG-701          Accessibility update: Updated Give Now Aria tags on funds to aria-checked
*   2025-02-13    Jassin Yacks (CFG)       CFG-751          Excluding physical products from the doner addToCart click event
*/

'use strict';
var base = require('base/product/base');

/**
 * Clears the modal if its been generated previously.
 *
 */
function getModalHtmlElement() {
    //clear any existing data in the modals
    $('#giftOptionsModal .modal-body').empty();
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
 function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}


/**
 * replaces the content in the modal window on for the selected product.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    //start spinner
    $.spinner().start();

    //AJAX call to the controller route in the URL passed in
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            //fill the gift options modal with data from the controller
            $('#giftOptionsModal .modal-body').append(data.optionsTemplate);
            //stop the spinner
            $.spinner().stop();
            //show the modal
            $('#giftOptionsModal').modal('show');
            //adjust the focus
            $('#giftOptionsModal').focus();
        },
        error: function () {
            console.log('error ecountered');
            $.spinner().stop();
        }
    });
}

/**
 * determines the donation amount to update the price and the frequency
 * @param {element} - element targeted
 * @returns {json} amount (number), frequency (text), subscriptionMode (text), isValidAmount (boolean), minAmount (integer), activeTabId (string)
 */
 function getGiftOptions(donateBtn) {
    var options;

    if(donateBtn){
        //declare variables
        var giftAmount;
        var giftFrequency;
        var subscriptionMode;
        var isValidAmount = true;
        var isSelectedAmount = true;
        var giftType;

        //find the active gift options tab (recurring or one time) and get the data-tab data property
        var activeTabId = $('.nav-link.active').attr('data-tab');

        //use the tab collected to get the currently selected and the manually entered amount
        var enteredAmount = $(donateBtn).closest('.tab-content').find('#custom-gift-amount-' + activeTabId)[0].value;
        var selectedAmount = parseFloat($(donateBtn).closest('.tab-content').find('#' + activeTabId + ' .giftamounts .selected').data('amount'));

        //if the selected number is NaN, use the entered amount, otherwise use the selected
        if(isNaN(selectedAmount)){
            giftAmount = Number(enteredAmount).toFixed(2);
            isSelectedAmount = false;
        }else{
            giftAmount = selectedAmount.toFixed(2);
        }

        //if 'recurring' is the selected tab, get the frequency value selected
        if(activeTabId === 'recurringData'){
            giftFrequency = $(donateBtn).closest('.tab-wrap').find('#recurringData #giftoptions-frequency')[0].value;
            subscriptionMode = 'regular';
            //set the gift type
            giftType = $('#recurringData').data('gift-type');
        }else{
            //otherwise, get the tab name for the 'one time' gift to ensure the proper text is displayed
            giftFrequency = $(donateBtn).closest('.tab-wrap').find('#onetimeTab')[0].innerText;
            subscriptionMode = 'onetime';
        }

        var maxAmount = parseInt($(donateBtn).closest('.tab-pane').find('#custom-gift-amount-' + activeTabId)[0].max);
        var minAmount = parseInt($(donateBtn).closest('.tab-pane').find('#custom-gift-amount-' + activeTabId)[0].min);

        //Set isValidAmount if the amount entered is below the min or above the max
        if((enteredAmount > maxAmount || minAmount > enteredAmount) && !isSelectedAmount){
            isValidAmount = false;
        }

        options = {
            amount: giftAmount,
            frequency: giftFrequency,
            subscriptionMode: subscriptionMode,
            isValidAmount: isValidAmount,
            minAmount: minAmount,
            activeTabId: activeTabId,
            giftType: giftType
        }

    }

    return options;
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {string} amount - amount selected/entered when adding to the cart
 * @param {string} frequency - recurring interval or 'one time'
 */
 function handlePostCartAdd(response, amount, frequency) {

    if(response){
        $('.minicart').trigger('count:update', response);
        var messageType = response.error ? 'alert-danger' : 'alert-success';

        // show add to cart toast
        if (response.newBonusDiscountLineItem
            && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
            chooseBonusProducts(response.newBonusDiscountLineItem);
        } else if(response.error) {
            if ($('.add-to-cart-messages').length === 0) {
                $('body').append(
                    `<div class="add-to-cart-messages alert ${messageType} alert-dismissible fade show" role="alert" tabindex="-1">
                        <h4 class="alert-heading">${response.title}</h4>
                        <p class="alert-message">${response.message}</p>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>`
                );
                $(".add-to-cart-messages").focus();
            }

        } else{
            //update the success modal with information from the product selected
            $('#giftAddedSuccessfullyModal .gift-added-component-image').attr('src', response.productImage);
            $('#giftAddedSuccessfullyModal .gift-added-component-image').attr('alt', response.imageAlt);
            $('#giftAddedSuccessfullyModal .gift-added-component-image').attr('title', response.imageTitle);
            $('#giftAddedSuccessfullyModal .slds-text-title_bold section').replaceWith('<section>' + response.productName + '</section>');
            $('#giftAddedSuccessfullyModal .gift-amount span').empty(); //clear existing value for amount
            $('#giftAddedSuccessfullyModal .gift-amount span').text('$' + amount); //set amount value
            $('#giftAddedSuccessfullyModal .gift-frequency span').empty(); //clear existing value for frequency
            $('#giftAddedSuccessfullyModal .gift-frequency span').text(frequency); //set frequency value

            $('.informative-alert-icon').show(); //display gift informative alert message and icon
            $('.gift-alert-icon').children().hide(); //hide gift alert validation message and icon

            $('#giftAddedSuccessfullyModal').modal('show'); //Display gift added successfully modal
        }

        //set/update a cookie for the cart quantity
        //to ensure cookies get set based on the site, only set the domain for non-prod & Development sites
        if((document.location.host).includes('.northeastern.edu')){
            document.cookie = 'cartcount=' + response.quantityTotal + '; path=/ ;samesite=lax; domain=northeastern.edu';
        }else{
            document.cookie = 'cartcount=' + response.quantityTotal + '; path=/ ;samesite=lax';
        }
    }
}

module.exports = {

    //these are either overwritten with custom logic or are custom functionality
    addToCart: function () {
        $(document).on('click', '.add-to-cart_donate', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;
            var giftAmount;
            var giftType;
            var giftFrequency;
            var isValidAmount;
            var minAmount;
            var subscriptionMode;
            var activeTabId;

            //starts the spinner
            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this).find('.product-id').text(),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = ($('.product-set-detail').length || $('.product-set').length) ? base.getPidValue($(this)) : $(e.target).data('pid');

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }

            addToCartUrl = getAddToCartUrl();

            //get the amount the donor selected/entered from the page and the frequency
            var buttonSelected = e.target;
            var options = getGiftOptions($(this));
            giftAmount = options.amount;
            subscriptionMode = options.subscriptionMode;
            giftFrequency = options.frequency;
            isValidAmount = options.isValidAmount;
            minAmount = options.minAmount;
            activeTabId = options.activeTabId;
            giftType = options.giftType;

            //quantity for gifts should always be 1, in case a quantity is added for another product later we are leaving in the standard
            //logic. If the base comes back with a 'null' we are setting it to 1
            var baseQuantity = base.getQuantitySelected($(this));

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                giftAmount: giftAmount,
                subscriptionMode: subscriptionMode, //align with SubscribePro
                deliveryInterval: giftFrequency, //align with SubscribePro
                availableIntervals: $('input[name=subproSubscriptionAvailableIntervals]').val(), //align with SubscribePro
                childProducts: getChildProducts(),
                quantity: baseQuantity ? baseQuantity : 1,
                giftType: giftType
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger('updateAddToCartFormData', form);

            //AJAX call to controller to add the product to the cart
            if (addToCartUrl && isValidAmount) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        handlePostCartAdd(data, giftAmount, giftFrequency);
                        $('body').trigger('product:afterAddToCart', data);
                        $.spinner().stop();
                        base.miniCartReportingUrl(data.reportingURL);
                        //close the gift options modal
                        if($('#giftOptionsModal')){
                            $('#giftOptionsModal').modal('hide');
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            } else {
                $(this).closest('.nav-tabs').find('#' + activeTabId + '_customamt').children('#alert-icon-' +  activeTabId).hide();
                $(this).closest('.nav-tabs').find('#' + activeTabId + '_customamt').find('#danger-icon-' +  activeTabId).removeAttr("hidden");

                if( minAmount > giftAmount){
                    $(this).closest('.nav-tabs').find('#' + activeTabId + '_customamt').find('#gift-alert-message-' + activeTabId + '-under').show();
                    $(this).closest('.nav-tabs').find('#' + activeTabId + '_customamt').find('#gift-alert-message-' + activeTabId + '-over').hide();
                } else{
                    $(this).closest('.nav-tabs').find('#' + activeTabId + '_customamt').find('#gift-alert-message-' + activeTabId + '-over').show();
                    $(this).closest('.nav-tabs').find('#' + activeTabId + '_customamt').find('#gift-alert-message-' + activeTabId + '-under').hide();
                }
                $.spinner().stop();
            }
        });
    },

    changeGiftAmount: function () {

        //When a users clicks any of the ask ladder amount buttons, update the styling and data properties
        $('body').on('click', '.giftamounts button', function (e) {

            //get the amount that is currently selected
            var currentlySelected = $(e.target).closest('ul').find('.selected');

            //update styling of the previously selected amount
            currentlySelected.removeClass('slds-button_brand slds-p-top_x-small slds-p-bottom_x-small selected').addClass('slds-button_neutral');

            // Reset aria-selected to false
            $('.giftamounts button').attr('aria-checked', 'false');
            // Update the aria-selected tag when clicked.
            $(e.target).attr('aria-checked', 'true');

            //updating styling of the selected amount
            $(e.target).removeClass('slds-button_neutral').addClass('slds-button_brand slds-p-top_x-small slds-p-bottom_x-small selected');

            //if the button selected is the 'other' option, show the custom entry textbox, otherwise hide it
            const intervalStng = (e.target.id).split('_')[0];
            if((e.target.id).includes('_otheramtbtn')){
                $(this).parents().parents().siblings('#' + intervalStng + '_customamt').show();
            }else{
                $(this).parents().parents().siblings('#' + intervalStng + '_customamt').hide();
            }
        });

    },

    //Prevent users from entering identified non-numerical characters
    limitGiftInputValues: function() {

        var invalidCharacters = ["-","+","e"];

        $('body').on('keydown','#custom-gift-amount-onetimeData, #custom-gift-amount-recurringData', function(e) {
            if((invalidCharacters.includes(e.key) || isNaN(e.key)) && e.keyCode != 8 && e.keyCode != 9 && e.key != '.'){
                e.preventDefault();
            }
        });
    },

    //limit a user from inputting more than two decimal places in the gift amount
    limitGiftDecimalPlaces: function() {
        $('body').on('input', '#custom-gift-amount-onetimeData, #custom-gift-amount-recurringData', function(e) {

            //setup a regex expression
            const allowedPattern = new RegExp(/^(\d+(\.\d{0,2})?)?$/);
            const inputValue = $(this).val();

            if (allowedPattern.test(inputValue)) {
                $(this).data('prevValue', $(this).val());
            } else {
                $(this).val($(this).data('prevValue') || '');
            }
        }).trigger('input');
    },

    //Add two decimal places to the gift amount value
    formatCustomGiftAmount : function() {
        $('body').on('blur', '#custom-gift-amount-onetimeData, #custom-gift-amount-recurringData', function(e) {

            var inputAmount = parseFloat(e.currentTarget.value);

            if(!isNaN(inputAmount)){
                e.currentTarget.value = Number(inputAmount).toFixed(2);
                e.currentTarget.setAttribute("value",Number(inputAmount).toFixed(2));
            }
        });
    },

    //Update the SLDS classes when tabs are switched
    updateTabStyle : function() {
        $('#giftOptionsTabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            e.target // newly activated tab
            e.relatedTarget // previous active tab
        });
    },

    //Include from SubscribePro - including for consistency with cartridge functionality, but these values will likely not be used
    //for this implementation. Modified from cartridge functionality to allow for actual input names/values from Gift Options tabs
    handleAddToCartSubOptions: function () {
        $(document).on('updateAddToCartFormData', function (e, data) {
            data.pliUUID = $('input[name=subproSubscriptionProductId]').val();
            data.discount = $('input[name=subproSubscriptionDiscount]').val();
            data.isDiscountPercentage = $('input[name=subproSubscriptionIsDiscountPercentage]').val();
        });
    },


    showQuickview: function () {
        var previousFocus;
        $('body').on('click', '.donate-btn', function (e) {
            e.preventDefault();
            previousFocus = document.activeElement;
            var selectedValueUrl = $(this).attr('href');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl);
        });
        $('#giftOptionsModal').on('hidden.bs.modal', function () {
            if (previousFocus) {
                previousFocus.focus();
            }
        });
    },
};
